import { render, staticRenderFns } from "./DataOfRam.vue?vue&type=template&id=3599aa43&"
import script from "./DataOfRam.vue?vue&type=script&lang=js&"
export * from "./DataOfRam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports